import styled, { css } from "styled-components";
import { Collapse } from "antd";
import {
  enterLeft,
  enterRight,
  enterTop,
} from "../Services/Sales/Checkout/styles";
const { Panel } = Collapse;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: #fafafa;
  min-height: 100vh;

  padding-bottom: 100px;
  overflow-y: auto;
  padding-bottom: 50px;
`;

export const CardsWrapper = styled.div`
  background-color: white;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 24px;
  border-radius: 8px;
  width: 1256px;
  @media (max-width: 1265px) {
    width: 95%;
  }

  box-shadow:
    1px 8px 20px 0px #c1c6cd17,
    -1px -1px 4px 0px #c1c6cd14;
  animation: ${enterTop} 1s;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background: #f8fafb;
  border-radius: 8px;
  width: 284px;
  height: 149px;
  padding: 16px;
  gap: 16px;
  box-shadow:
    1px 8px 4px 0px #a8b7be17,
    -1px -1px 4px 0px #a8b7be26;

  cursor: pointer;
  transition:
    transform 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  }
  @media (max-width: 900px) {
    width: 95%;
  }
`;

export const CardContent = styled.div``;

export const CardTitle = styled.p`
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  line-height: 100%;
  font-weight: bold;
  color: #020618;
  font-family: "Inter";
  @media (max-width: 1265px) {
    font-size: 16px;
  }
  @media (max-width: 645px) {
    font-size: 14px;
  }
`;
export const CardDescription = styled.p`
  font-size: 16px;
  line-height: 100%;
  margin-bottom: 0;
  font-family: "Inter";
  color: 314158;
  @media (max-width: 1265px) {
    font-size: 14px;
  }
  @media (max-width: 645px) {
    font-size: 12px;
  }
`;

export const PanelWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-top: 25px;
  max-width: 1256px;
  width: 100%;
  gap: 16px;

  flex-wrap: wrap;
`;

export const PanelContent = styled.div`
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  max-width: 620px;
  width: 100%;
  height: 564px;
  background: rgba(255, 255, 255, 1);
  padding: 24px;
  margin: 0 auto;

  box-shadow:
    1px 8px 4px 0px #a8b7be17,
    -1px -1px 4px 0px #a8b7be26;

  /* @media (max-width: 1265px) {
    width: 100%;
  } */
  @media (max-width: 520px) {
    width: 375px;
  }

  animation: ${enterLeft} 1s;

  .content {
    width: 100%;
  }

  ${({ right }) =>
    right &&
    css`
      animation: ${enterRight} 1s;
    `}
`;
export const IconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: auto;
  width: 100%;
  align-items: center;
`;

export const IconWrapper = styled.div`
  font-size: 24px;
  background: ${(props) => props.background || "#000"};
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  height: 40px;

  box-shadow: 0px 2px 10px 4px ${(props) => props.shadowColor || "transparent"};
`;

export const ContainerTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  margin-left: 5px;
`;

export const TitlePanel = styled.p`
  font-size: 18px;
  font-family: "Inter";
  font-weight: 600;
  color: #020618;
  line-height: 100%;
  justify-self: start;
  align-self: flex-start;
  margin-bottom: 24px;
`;

export const SubTitlePanel = styled.p`
  font-size: 16px;
  font-family: "Inter";
  font-weight: 600;
  color: #020618;
  line-height: 130%;
  align-items: start;
  justify-content: start;
  width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: ellipsis;
  margin-bottom: 0;
  @media (max-width: 550px) {
    font-size: 14px;
  }
`;

export const Key = styled.span`
  color: #62748e;
  font-family: "Inter";
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
`;

export const SubTitleHistory = styled(SubTitlePanel)`
  margin-bottom: 16px;
  width: 100%;
`;

export const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TextDetailsPanel = styled.p`
  font-size: 14px;
  margin-bottom: 0;
  font-family: "Inter", sans-serif;
  line-height: 100%;
  @media (max-width: 550px) {
    font-size: 12px;
  }

  ${({ type }) => {
    switch (type) {
      default:
      case "info":
        return css`
          color: #62748e;
          font-weight: 400;
        `;
      case "title":
        return css`
          color: #314158;
          font-weight: 600;
        `;
    }
  }}
`;

export const PriceDetailsPanel = styled.p`
  margin-bottom: 0;
  font-size: 16px;
  font-family: "Inter";
  display: flex;
  justify-content: end;
  color: #314158;
  line-height: 100%;
  width: fit-content;
  @media (max-width: 550px) {
    font-size: 14px;
    width: 120px;
  }
`;

export const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 15px 6px;
  border-radius: 8px;
  width: 100%;
  margin-bottom: 14px;
`;

export const StatItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  flex: 1 1 0;
  min-width: 0;
  gap: 4px;

  &:nth-child(1)::after {
    content: "";
    position: absolute;
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    height: 32px;
    width: 1px;
    background-color: #90a1b9;
  }
`;

export const StatNumber = styled.span`
  font-size: 15px;
  font-weight: bold;
  font-family: "Inter";
  line-height: 100%;
  color: #020618;
  @media (max-width: 1265px) {
    font-size: 12px;
  }
`;

export const StatLabel = styled.span`
  font-size: 11px;
  font-family: "Inter";
  line-height: 100%;
  color: rgba(98, 116, 142, 1);
  width: 100%;
  text-align: center;
  white-space: nowrap;
  @media (max-width: 1265px) {
    font-size: 9px;
  }
`;

export const ListWrapperLeft = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: center;
  align-items: center;
  margin-bottom: 24px;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ListWrapperRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  flex-direction: center;
  align-items: center;
  margin-bottom: 15px;
`;

export const ListInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const CredentialsStatus = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  border-radius: 8px;
  gap: 8px;
  justify-content: center;
  font-size: 14px;
  line-height: 100%;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  margin-left: auto;

  height: 25px;
  gap: 8px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 8px;

  ${({ status }) => {
    switch (status) {
      default:
      case "WITHDRAWN":
        return css`
          background-color: #f1f5f9;
          color: #314158;
          svg > circle {
            fill: #314158;
          }
        `;
      case "PRINTED":
        return css`
          background-color: #ffebf0;
          color: #bf1b4f;
          svg > circle {
            fill: #bf1b4f;
          }
        `;
      case "AVAILABLE":
        return css`
          background-color: #defaea;
          color: #1d9c59;
          svg > circle {
            fill: #1d9c59;
          }
        `;
      case "ASSOCIATED":
        return css`
          background-color: #fff4d7;
          color: #c0780c;
          svg > circle {
            fill: #c0780c;
          }
        `;
    }
  }}
`;

export const ContractInfoWrapper = styled.div`
  display: flex;
  // flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 1256px;

  margin-top: 130px;
  @media (max-width: 1265px) {
    width: 95%;
  }

  animation: ${enterTop} 1s;
`;

export const ContractNumber = styled.div`
  background-color: #f0faff;
  color: #068ec3;
  border-radius: 8px;
  display: inline-block;
  font-size: 14px;
  padding: 0px 16px;
  font-weight: 700;
  font-family: "Inter";
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  height: 25px;

  ${({ event }) =>
    event &&
    css`
      font-size: 16px;
      font-weight: 600;
      margin: 0 auto;
      margin-bottom: 8px;
    `}
`;

export const ContractName = styled.h1`
  font-weight: bold;
  font-size: 24px;
  line-height: 100%;
  margin-bottom: 30px;
  font-family: "Inter";
  color: #314158;
  text-transform: capitalize;
  margin-bottom: 20px;
`;

export const ScrollContainer = styled.div`
  max-height: auto;
  overflow-y: scroll;
  scrollbar-width: none;
  width: 100%;

  ${({ error }) =>
    error &&
    css`
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

export const StyledCollapse = styled(Collapse)`
  border: none;
  box-shadow: none;
  background: #fff;
  width: 100%;

  .ant-collapse-header {
    padding: 8px !important;
  }

  .ant-collapse-header-text {
    width: 90%;
    display: block;
    flex: unset !important;
  }
`;

export const StyledPanel = styled(Panel)`
  width: 100%;
  border: none !important;
  background: transparent !important;
  padding: 0 !important;

  .ant-collapse-header {
    border: none !important;
  }

  .ant-collapse-content {
    border: none !important;
    background: transparent !important;
  }
  // @media (max-width: 1265px) {
  //   width: 560px;
  // }
  // @media (max-width: 1200px) {
  //   width: 400px;
  // }
`;

export const DropDetails = styled.div`
  margin-left: -2px;
  margin-top: -23px;
`;
export const EndServiceItens = styled.div`
  display: block;
  align-items: center;
  background: transparent;
  justify-items: end;
  margin-bottom: 20px;
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  color: #068ec3;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-family: "Inter";
  padding: 0;
  font-weight: 600;
  transition: color 0.2s;
  &:hover {
    color: #2b4468;
    text-decoration: underline;
  }
`;

const SCHEDULE_STATUS_STYLES = {
  SCHEDULED: {
    background: "rgb(238, 248, 241)",
    border: "1px solid rgb(9, 155, 69)",
    color: "rgb(9, 155, 69)",
  },
  default: {
    background: "rgb(248, 248, 250)",
    border: "1px solid #C8D3E1",
    color: "#62748E",
  },
};

export const SchedulingStatusCard = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  min-height: 80px;
  margin-bottom: 14px;
  border-radius: 8px;
  align-items: center;
  justify-content: flex-start;
  padding: 0 15px;
  gap: 12px;
  font-size: 14px;
  line-height: 100%;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  padding: 8px;

  background: ${({ status }) =>
    (SCHEDULE_STATUS_STYLES[status] || SCHEDULE_STATUS_STYLES.default)
      .background};
  border: ${({ status }) =>
    (SCHEDULE_STATUS_STYLES[status] || SCHEDULE_STATUS_STYLES.default).border};
  color: ${({ status }) =>
    (SCHEDULE_STATUS_STYLES[status] || SCHEDULE_STATUS_STYLES.default).color};

  span {
    font-size: 14px;
    line-height: 100%;
    font-family: "Inter", sans-serif;
    font-weight: 700;
    margin-right: 4px;
  }
`;

export const StatusContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
`;

export const NavegationButtom = styled.div`
  color: rgb(9, 155, 69);
  font-size: 14px;
  font-family: "Inter";
  font-weight: 600;
  line-height: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  margin-left: auto;
  &:hover {
    color: "rgb(29, 156, 89)";
    text-decoration: underline;
  }
`;
export const ScheduleInfoText = styled.div`
  color: rgb(109, 118, 136);
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
`;

export const ScheduleDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  font-weight: 500;
`;
